import { SequenceType, TypeArray } from "../types"
import { reducerTypeGuard } from "../reducers/reducerGuards"
import { actionCreatorTypeGuard } from "../reducers/actionCreators"

export type SeqRef = {
  type: SequenceType
  id: string
}

const reducerAction = {
  type: actionCreatorTypeGuard<SeqRef, SequenceType>("type", "SeqRef"),
  id: actionCreatorTypeGuard<SeqRef, string>("id", "SeqRef"),
  __record: actionCreatorTypeGuard<TypeArray, SeqRef>("SeqRef", "__record"),
  __create: actionCreatorTypeGuard<TypeArray, null | Partial<SeqRef>>(
    "create",
    "__create/SeqRef"
  ),
  __delete: actionCreatorTypeGuard<TypeArray, number>("delete", "__record")
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in
    | keyof SeqRef
    | "__record"
    | "__delete"
    | "__create"]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const seqRefAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const seqRefReducer = reducerTypeGuard<SeqRef>()
  .case(...reducerAction.type)
  .case(...reducerAction.id)
  .build()
